/**
 * Booking API
 *
 * Contact: support@xenoncloud.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type BasketPriceInfoCodeType = 'GIFT_CARD' | 'DISCOUNT' | 'UNKNOWN';

export const BasketPriceInfoCodeType = {
  GIFT_CARD: 'GIFT_CARD' as BasketPriceInfoCodeType,
  DISCOUNT: 'DISCOUNT' as BasketPriceInfoCodeType,
  UNKNOWN: 'UNKNOWN' as BasketPriceInfoCodeType
};
